module.exports = __webpack_public_path__ + "static/media/JD Homepage-09_cc-09.60d41232.svg";